import React, { Component } from "react";

import { captureReactException } from "@stadium/services/error-reporting";
import { handle401 } from "@stadium/helpers/src/error-handler";

import { axiosInstance, axiosGraphqlInstance, axiosUsersGraphqlInstance } from "@services/axios";

const ErrorFallback = () => (
  <div className="container mt-5">
    <section className="text-center">
      <h1 className="jumbotron-heading text-theme-primary">Something went wrong!</h1>
      <p className="lead text-muted mb-5">
        Our team has been notified. Meanwhile, you may refresh the page or try again.
      </p>
    </section>
  </div>
);

class ErrorBoundary extends Component {
  state = { hasError: false };

  componentDidCatch(error, info) {
    this.setState({ hasError: true });
    captureReactException(error, info, { mechanism: { handled: true } });
  }

  componentDidMount() {
    [axiosInstance, axiosGraphqlInstance, axiosUsersGraphqlInstance].forEach((instance) => {
      instance.interceptors.request.use(
        (response) => response,
        (error) => handle401(error),
      );
    });
  }

  render() {
    const { fallback = "", useDefault, children } = this.props;
    const { hasError } = this.state;
    if (hasError) {
      return useDefault ? <ErrorFallback /> : fallback;
    }

    return children;
  }
}

export default ErrorBoundary;
